<template>
	<div class="flex flex-column">
		<Form class="p-16px flex-1" ref="form" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
			<FormItem label="账套名称:" prop="companyName">
				<Input type="text" v-model="form.companyName"/>
			</FormItem>
			<FormItem label="账套启用年月:" prop="enableDate">
				<DatePicker type="month" v-model="form.enableDate" :disabled="used" :clearable="false"/>
			</FormItem>

      <FormItem label="会计主管:" prop="manager">
        <Input type="text" v-model="form.director"/>
      </FormItem>

      <FormItem label="凭证导入自动编号:" prop="autoVoucherCode" >
        <Select :deletable="false" v-model="form.autoVoucherCode" :datas="voucherExclusives"/>
      </FormItem>

      <FormItem label="凭证纸张尺寸:" prop="voucherSize">
        <Select :deletable="false" v-model="form.voucherSize" :datas="voucherSizes"/>
      </FormItem>
      <FormItem label="凭证打印分录条数:" prop="voucherEntrySize">
        <Select :deletable="false" v-model="form.voucherEntrySize" :datas="voucherEntrySizes"/>
      </FormItem>
      <FormItem label="凭证打印换页:" prop="exclusive" v-if="form.voucherSize=='A4'">
        <Select :deletable="false" v-model="form.exclusive" :datas="voucherExclusives"/>
      </FormItem>
      <FormItem label="明细账打印方向:" prop="voucherDetailPrintDirection">
        <Select :deletable="false" v-model="form.voucherDetailPrintDirection" :datas="printDirections"/>
      </FormItem>
      <FormItem label="是否启用无纸化:" prop="usePaperLess" >
        <Select :deletable="false" v-model="form.usePaperLess" :datas="voucherExclusives"/>
      </FormItem>
      <FormItem label="明细账页码位置:" prop="voucherDetailPageNumPosition">
        <Select :deletable="false" v-model="form.voucherDetailPageNumPosition" :datas="pageNumPositions"/>
      </FormItem>
      <FormItem label="单位代码">
        <Input type="text" v-model="form.companyCode"/>
      </FormItem>

<!--			<FormItem label="统一社会信用代码:">-->
<!--				<Input type="text" v-model="form.creditCode"/>-->
<!--			</FormItem>-->
<!--			<FormItem label="会计准则:" prop="accountStandard">-->
<!--				<Select :deletable="false" v-model="form.accountStandard" dict="accountingStandards" :disabled="!!form.id"/>-->
<!--			</FormItem>-->
<!--			<FormItem label="单位所在地:">-->
<!--				<CategoryPicker ref="CategoryPicker" :option="pickerOption" type="key" showAllLevels v-model="form.address"></CategoryPicker>-->
<!--			</FormItem>-->
<!--			<FormItem label="行业:">-->
<!--				<Select v-model="form.industry" dict="industry"></Select>-->
<!--			</FormItem>-->
<!--			<FormItem label="增值税种类:" prop="vatType">-->
<!--				<Radio v-model="form.vatType" dict="vatRadios" :disabled="!!form.id"></Radio>-->
<!--			</FormItem>-->
<!--			<FormItem label="凭证是否需要审核:" prop="voucherReviewed">-->
<!--				<Radio v-model="form.voucherReviewed" dict="needRadios"></Radio>-->
<!--			</FormItem>-->
		</Form>
		<div class="text-center">
			<Button @click="$emit('close')" :loading="loading">取消</Button>
			<Button color="green" @click="submit" :loading="loading">{{ form.id ? '更新' : '创建' }}账套</Button>
		</div>
	</div>
</template>

<script>
import {getTotalData} from "@/js/locations/district";
import {clone} from "xe-utils";
import moment from "moment/moment";

/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */

const emptyForm = {
	"accountStandard": "NONGOVERNMENTAL",
	"address": null,
	"companyName": "",
	"creditCode": "",
	"enableDate": null,
	"voucherReviewed": true,
	"industry": null,
	"vatType": "SMALL_SCALE",
  "voucherSize": 'A5',
  "director": '',
  "exclusive": false,
  "autoVoucherCode": true,
  "voucherEntrySize": 8,
  "voucherDetailPrintDirection": "横向",
  "voucherDetailPageNumPosition": "底部",
  "companyCode": "",
};

export default {
	name: "AccountForm",
	props: {
		entity: Object,
	},
	data() {
		return {
			loading: false,
			pickerOption: {
				keyName: 'id',
				titleName: 'title',
				dataMode: 'list',
				parentName: 'parentId',
				datas: getTotalData()
			},
      voucherSizes:['A4','A5'],
      voucherEntrySizes:[{title:'8条',key:8},{title:'14条',key:14}],
      voucherExclusives:[{title:'否',key:false},{title:'是',key:true}],
      printDirections:[{title:'横向',key:'横向'},{title:'纵向',key:'纵向'}],
      pageNumPositions:[{title:'底部',key:'底部'},{title:'顶部',key:'顶部'},{title:'无页码',key:'无页码'}],
			form: clone(emptyForm),
			validationRules: {
				required: ["companyName", "enableDate", "accountingStandards", "fixed_asset_module", "cashier_module", "voucherReviewed", "vatType"]
			},
		}
	},
	methods: {
		submit() {
			let validResult = this.$refs.form.valid();
			if (validResult.result) {
				this.loading = true;
				this.form.enableDate = moment(this.form.enableDate).format("YYYY-MM-DD");
				this.$api.setting.accountSets[this.form.id ? 'update' : 'save'](this.form).then(() => {
					window.location.reload();
				}).catch(() => {
					this.loading = false;
				})
			}
		}
	},
	created() {
		if (this.entity) {
			this.form = clone(this.entity);
		}
	}
}
</script>
